import { ECrsTypOsoby } from 'services/poDlt/crs';

const crsTypOsobySelect = [
    {
        value: ECrsTypOsoby.CRS801,
        labelcz: 'CRS_OSOBA_CRS801'
    },
    {
        value: ECrsTypOsoby.CRS802,
        labelcz: 'CRS_OSOBA_CRS802'
    },
    {
        value: ECrsTypOsoby.CRS803,
        labelcz: 'CRS_OSOBA_CRS803'
    },
    {
        value: ECrsTypOsoby.CRS804,
        labelcz: 'CRS_OSOBA_CRS804'
    },
    {
        value: ECrsTypOsoby.CRS805,
        labelcz: 'CRS_OSOBA_CRS805'
    },
    {
        value: ECrsTypOsoby.CRS806,
        labelcz: 'CRS_OSOBA_CRS806'
    },
    {
        value: ECrsTypOsoby.CRS807,
        labelcz: 'CRS_OSOBA_CRS807'
    },
    {
        value: ECrsTypOsoby.CRS808,
        labelcz: 'CRS_OSOBA_CRS808'
    },
    {
        value: ECrsTypOsoby.CRS809,
        labelcz: 'CRS_OSOBA_CRS809'
    },
    {
        value: ECrsTypOsoby.CRS810,
        labelcz: 'CRS_OSOBA_CRS810'
    },
    {
        value: ECrsTypOsoby.CRS811,
        labelcz: 'CRS_OSOBA_CRS811'
    },
    {
        value: ECrsTypOsoby.CRS812,
        labelcz: 'CRS_OSOBA_CRS812'
    },
    {
        value: ECrsTypOsoby.CRS813,
        labelcz: 'CRS_OSOBA_CRS813'
    }
];

export default crsTypOsobySelect;
